var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgHistoricalModule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.823,
    height: 18.6,
    viewBox: "0 0 14.823 18.6"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-historical-module_svg__cls-3{stroke:#119aeb;stroke-linecap:round;fill:none;stroke-width:1.6px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-historical-module_svg__ICN_Modul_Istoric_Active",
    "data-name": "ICN_Modul Istoric_Active",
    transform: "translate(.201 .995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-historical-module_svg__Group_1217",
    "data-name": "Group 1217",
    transform: "translate(0 -.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-historical-module_svg__Group_1216",
    "data-name": "Group 1216",
    strokeLinejoin: "round",
    stroke: "#119aeb",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-historical-module_svg__Path_875",
    d: "M1.81 3.787a1.945 1.945 0 00-1.8 2.07 1.72 1.72 0 001.851 1.576A1.494 1.494 0 003.21 5.799a1.268 1.268 0 00-1.419-1.12 1.041 1.041 0 00-.887 1.209.877.877 0 00.346.531.752.752 0 00.663.113.647.647 0 00.368-.295.54.54 0 000-.548.377.377 0 00-.308-.195.344.344 0 00-.256.049.37.37 0 00-.15.289.266.266 0 00.077.191.24.24 0 01-.08-.038.372.372 0 01-.136-.208.515.515 0 01.448-.571.74.74 0 01.805.66.965.965 0 01-.876 1.036A1.19 1.19 0 01.542 5.808a1.415 1.415 0 011.313-1.489H12.57a1.416 1.416 0 011.313 1.489 1.19 1.19 0 01-1.263 1.093.965.965 0 01-.876-1.035.74.74 0 01.805-.66.514.514 0 01.448.571.37.37 0 01-.136.208.25.25 0 01-.08.038.268.268 0 00.077-.191.371.371 0 00-.15-.29.343.343 0 00-.257-.049.377.377 0 00-.308.195.539.539 0 000 .548.646.646 0 00.368.295.752.752 0 00.663-.113.877.877 0 00.346-.531 1.041 1.041 0 00-.887-1.209 1.268 1.268 0 00-1.419 1.12 1.494 1.494 0 001.349 1.634 1.719 1.719 0 001.851-1.576 1.946 1.946 0 00-1.8-2.07.508.508 0 00-.063 0H1.872a.465.465 0 00-.063 0z",
    "data-name": "Path 875",
    fill: "#009ceb",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "kpmg-historical-module_svg__Rectangle_308",
    width: 9,
    height: 2,
    "data-name": "Rectangle 308",
    rx: 1,
    transform: "translate(3)",
    fill: "none",
    strokeWidth: 1.6
  }))), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-historical-module_svg__Path_876",
    d: "M1.2 0h3.607a1.185 1.185 0 011.2 1.166v7.582a1.185 1.185 0 01-1.2 1.166H1.2A1.185 1.185 0 010 8.748V1.166A1.185 1.185 0 011.2 0z",
    className: "kpmg-historical-module_svg__cls-3",
    "data-name": "Path 876",
    transform: "translate(4.206 6.89)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-historical-module_svg__Line_138",
    d: "M0 0v5.537",
    className: "kpmg-historical-module_svg__cls-3",
    "data-name": "Line 138",
    transform: "translate(6.309 9.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-historical-module_svg__Line_139",
    d: "M0 0v5.537",
    className: "kpmg-historical-module_svg__cls-3",
    "data-name": "Line 139",
    transform: "translate(8.112 9.164)"
  }))));
}

export default SvgKpmgHistoricalModule;